module.exports = __webpack_public_path__ + "img/github.256ca983.svg";